import React from 'react';
import TodoPage from './features/todo/TodoPage';

function App(): JSX.Element {
  return <TodoPage />;
}

export default App;
